/* istanbul ignore file */
import { createApi } from "@reduxjs/toolkit/query/react";
import baseQuery from "../utils/baseQuery";
import { showNotifier, setGlobalLoader } from "../../store/globalSlice";
import { setItemPogSummaryDetails } from "../../store/itemPogSummarySlice";
import store from "../../store";
import config from "../../config";

// Get access token directly from redux store.
const getAuthHeaders = () => ({
  Authorization: `Bearer ${store.getState()?.global?.authState?.id_token}`,
});

export const itemPogSummaryApi = createApi({
  reducerPath: "itemPogSummary/api",
  tagTypes: ["ItemPogSummary"],
  baseQuery: baseQuery({ baseUrl: config.PogBaseUrl }),
  endpoints: (builder) => ({
    getItemPogSummary: builder.query({
      providesTags: ["ItemPogSummary"],
      query: ({
        storeId,
        departmentLetter,
        category,
        planogramValue,
        vendorName,
        skuNumber,
      }) => ({
        url: config.GetItemPogSummary,
        method: "post",
        headers: getAuthHeaders(),
        data: {
          storeId,
          departmentLetter,
          category,
          planogramValue,
          vendorName,
          skuNumber,
        },
      }),
      async onQueryStarted(_details, { dispatch, queryFulfilled }) {
        try {
          if (_details?.type === "initialLoad") {
            dispatch(setGlobalLoader(true));
          }
          const { data } = await queryFulfilled;
          dispatch(setGlobalLoader(false));
          dispatch(setItemPogSummaryDetails(data[0]));
        } catch {
          dispatch(setGlobalLoader(false));
          dispatch(
            showNotifier({
              message: "Something went wrong. Please try again.",
              severity: "error",
            })
          );
        }
      },
    }),
  }),
});

export const { useLazyGetItemPogSummaryQuery } = itemPogSummaryApi;
